import 'izitoast/dist/css/iziToast.min.css'
import iZtoast from 'izitoast'

// export const toast = {
    export  function _error (message, title = 'Hata')  {
        return iZtoast.error({
            title: title,
            message: message,
            position: 'bottomRight'
        });
    }
    export  function _success (message, title = 'Başarılı')  {
        return iZtoast.success({
            title: title,
            message: message,
            position: 'bottomRight'
        });
    }
    export  function _info (message, title = 'Bilgi')  {
        return iZtoast.info({
            title: title,
            message: message,
            position: 'bottomRight'
        });
    }
    export  function _warning (message, title = 'Uyarı')  {
        return iZtoast.warning({
            title: title,
            message: message,
            position: 'bottomRight'
        });
    }
// };
